export default "__VITE_ASSET__CRM1HQmC__"